<div class="container">
  <div class="row">
    <div class="col-sm-8 col-sm-offset-2">
      <h3>Set new password</h3>
      <p class="text-muted">Please set a new password for easy access.</p>
      <app-set-password></app-set-password>
    </div>
  </div>
</div>

<app-notifications></app-notifications>
